import Navigation from "../components/Navigation";
import NeuralNexusHero from "../components/NeuralNexusHero";
import BeastGrid from "../components/BeastGrid";
import AxiomDigitalStudio from "../components/AxiomDigitalStudio";
import RoadmapAndSkills from "../components/RoadmapAndSkills";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <main>
      <Navigation />
      <NeuralNexusHero />
      <BeastGrid />
      <AxiomDigitalStudio />
      <RoadmapAndSkills />
      <Footer />
    </main>
  );
}

